import { useEffect, useState } from 'react';
import { ROUTES } from '@/routes';

/** Keeps Media Metrics mounted after first visit so route switches do not remount heavy charts. */
export function useMediaMetricsRouteCache(pathname: string) {
  const onMediaMetrics = pathname === ROUTES.MEDIA_METRICS;
  const [everVisited, setEverVisited] = useState(false);

  useEffect(() => {
    if (onMediaMetrics) setEverVisited(true);
  }, [onMediaMetrics]);

  return {
    onMediaMetrics,
    showMediaMetricsCache: onMediaMetrics || everVisited,
  };
}
